import * as React from 'react';
import { ReactStateType } from '../../Map';
import { Constraints, ConstraintType } from '../ModalCalendar';
import HotelNightsConstraint from './hotelNights';
import OpeningTimesConstraint from './openingTimes';
import PlanifiedEventsConstraint from './planifiedEvents';
import VisitDurationConstraint from './visitDuration';
import WorkingDaysConstraint from './workingDays';

export type ConstraintProps = {
	constraintsHook: ReactStateType<Map<Constraints, unknown | undefined>>
	defaultConstraints: ConstraintType
}

export default function Constraint(props: ConstraintProps & { constraint: Constraints }) {
	const _ = React;
	switch (props.constraint) {
		case 'PlanifiedEvents': {
			return <PlanifiedEventsConstraint {...props} />;
		}
		case 'OpeningTimes': {
			return <OpeningTimesConstraint {...props} />;
		}
		case 'VisitDuration': {
			return <VisitDurationConstraint {...props} />;
		}
		case 'HotelNights': {
			return <HotelNightsConstraint {...props} />;
		}
		case 'WorkingDays': {
			return <WorkingDaysConstraint {...props} />;
		}
	}
}
